import React, { Fragment, useState, useEffect, useRef } from "react";
import { Redirect, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import Button from "@mui/material/Button";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import { Link, Navigate, useNavigate } from "react-router-dom";
import "react-quill/dist/quill.snow.css"; // Add this line
import Lottie from "lottie-react";
import loading from "../components/loading.json";
import { themeStyle, themeStyleDark } from "../components/Components";
import Backdrop from "@mui/material/Backdrop";
import Sidebar from "../components/Sidebar";
import Footer from "../components/Footer";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import { Grid } from "@mui/material";
import XIcon from "@mui/icons-material/X";
import InstagramIcon from "@mui/icons-material/Instagram";
import FacebookIcon from "@mui/icons-material/Facebook";
import EmailIcon from "@mui/icons-material/Email";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import LocalPhoneIcon from "@mui/icons-material/LocalPhone";
import VisitUs from "../components/VisitUs";
import CountUp from "react-countup";
import { API_URL } from "../actions/auth";
import axios from "axios";
import "react-quill/dist/quill.core.css";
import background from "../img/1.jpg";

function getBlogImageUrl(content) {
  if (!content?.image_url) {
    return background;
  }
  if (content.image_url.startsWith("http")) {
    return content.image_url;
  }
  return API_URL + content.image_url.replace(/^\//, "");
}

export default function BlogPage() {
  const state = useSelector((state) => state);
  const location = useLocation();
  const [content, setContent] = useState("");
  const [author, setAuthor] = useState("");

  useEffect(() => {
    axios
      .post(API_URL + "get_blog_content", {
        slug: location.pathname.split("/")[2].replaceAll("/", ""),
      })
      .then((res) => {
        setContent(res.data["content"]);
        setAuthor(res.data["author"]);
      });
  }, []);

  function getContent() {
    return (
      <div
        className={"anigrad"}
        style={{
          textAlign: "left",
        }}
      >
        <Sidebar />
        <div
          style={{
            display: "flex",
            backgroundColor: "#111",
            marginTop: state.auth.isMobile ? "2.2vh" : "12vh",
            height: "60vh",
            justifyContent: "center",
            backgroundPosition: "center",
            backgroundSize: "cover",
            alignItems: "center",
            width: "100vw",
            backgroundImage: "url('" + getBlogImageUrl(content) + "')",
          }}
        ></div>
        <div
          style={{
            width: "100%",
            padding: "15px",
            backgroundColor: "white",
          }}
        >
          <Grid container>
            <Grid item xs={0} md={2}></Grid>
            <Grid item xs={12} md={8}>
              <h1
                style={{
                  color: "black",
                }}
              >
                {content.title}
              </h1>
              <div
                className="ql-editor"
                dangerouslySetInnerHTML={{ __html: content.content }}
              />
              <Link
                to={"/about-author/" + author.auth_id + "/"}
                params={{ auth_id: author.auth_id }}
                style={{
                  width: "100%",
                  cursor: "pointer",
                  textDecoration: "none",
                  margin: "15px",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-start",
                    alignItems: "flex-start",
                    flexDirection: state.auth.isMobile ? "column" : "row",
                    width: "100%",
                    marginTop:
                      state.auth.view == "TABP"
                        ? "-375px"
                        : state.auth.isMobile
                        ? "-475px"
                        : "-375px",
                    marginBottom:
                      state.auth.view == "TABP"
                        ? "-500px"
                        : state.auth.isMobile
                        ? "500px"
                        : "500px",
                  }}
                >
                  <img
                    src={API_URL + author.image}
                    alt={author.name}
                    style={{
                      marginRight: "25px",
                      maxHeight: "150px",
                      maxWidth: "150px",
                      minHeight: "150px",
                      minWidth: "150px",
                      borderRadius: "150px",
                      border: "2px solid black",
                      objectFit: "cover",
                    }}
                  />
                  <div>
                    <div
                      style={{
                        color: "black",
                        textAlign: "left",
                        fontSize: "3vh",
                        fontWeight: "bold",
                      }}
                    >
                      {author.name}
                    </div>
                    <div
                      style={{
                        color: "black",
                        textAlign: "left",
                        fontSize: "2vh",
                        fontWeight: "bold",
                      }}
                    >
                      {author.designation}
                    </div>
                    <div
                      style={{
                        color: "black",
                        textAlign: "left",
                        fontSize: "1.6vh",
                        fontStyle: "italic",
                      }}
                    >
                      {author.description}
                    </div>
                  </div>
                </div>
              </Link>
            </Grid>
            <Grid item xs={0} md={2}></Grid>
          </Grid>
        </div>
        <Footer />
      </div>
    );
  }

  return (
    <div
      style={{
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor:
          state.auth.theme == "dark"
            ? themeStyleDark.backgroundColor
            : themeStyle.backgroundColor,
        transition: "opacity 2s",
      }}
    >
      {getContent()}
    </div>
  );
}
